import * as React from "react";
import * as moment from "moment";

import {IMessage, Message} from './Message';
import {Col, Row, Spin, Tag} from "antd";

interface IProps {
  messages: IMessage[];
}

export const MessagesList = (props: IProps) => {

  let lastAuthor = ''; // last author displayed
  let lastDate = ''; // last date displayed

  const messagesList: any[] = [];

  props.messages.forEach((message) => {
    let msgDate = '-';
    let msgKey = 0;
    try {
      msgDate = moment.unix(message.timestamp.seconds).format('DD-MM-YYYY');
      msgKey = message.timestamp.seconds;
    } catch (error) {
      msgDate = '-';
    }

    if (msgDate !== lastDate) {
      messagesList.push(
        <Row type='flex' justify='center' key={msgDate}>
          <Tag>{msgDate}</Tag>
        </Row>
      )
    }
    lastDate = msgDate;

    if (message.author === lastAuthor) {
      messagesList.push(<Message key={msgKey} message={message} showAuthor={false}/>);
    } else {
      messagesList.push(<Message key={msgKey} message={message} showAuthor={true}/>);
    }
    lastAuthor = message.author;

  });

  return(
    <div>
      {props.messages.length > 0 ? messagesList : <NoMessagesYet /> }
    </div>
  );
};

const NoMessagesYet = () => (
  <Row type='flex' justify='center' >
    <Col>
      No messages yet, be the first to write :)
    </Col>

  </Row>
);